import { createFileRoute } from "@tanstack/react-router";
import { requireActive } from "../lib/require-active";
import { pageHead } from "../lib/utils";

export const Route = createFileRoute("/")({
  head: () => pageHead("page.dashboard"),
  beforeLoad: ({ context }) => {
    requireActive(context);
  },
});
